/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';

import template from './team-edit-fees.component.html';
import {ADVERTISING_SHARED} from '../../advertising/advertising-shared';
import {TeamFeeComponent} from './team-fee-component';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED, TeamFeeComponent],
  selector: 'adn-team-edit-fees',
  template
})
export class TeamEditFeesComponent {
  @Input() model: any;
  @Input() canSeeTechFees: boolean;
  @Input() targetTypes: any[] = [];
  @Input() readOnly = false;

  @Output() changed = new EventEmitter<void>();
  @Output() supplementaryFeeAdd = new EventEmitter<void>();
  @Output() supplementaryFeeDelete = new EventEmitter<number>();
  @Output() layoutFeeRemove = new EventEmitter<number>();
  @Output() layoutFeeAdd = new EventEmitter<void>();
  @Output() targetingFeeRemove = new EventEmitter<number>();
  @Output() targetingFeeAdd = new EventEmitter<void>();

  trackByIndex(index: number): number {
    return index;
  }

  onChange(): void {
    this.changed.emit();
  }
}
